import '../static/major/scss/features/compare.scss';
